// extracted by mini-css-extract-plugin
export default {"container":"ColorSpaceToggle_container__Ui10H","button":"ColorSpaceToggle_button__lSA22","active":"ColorSpaceToggle_active__7ewpE"};